(function ($) {
	// on dom ready
	// check to see if any links in the main nav match the current url
	const navLinks = document.querySelectorAll('.main-nav a');
	// const currentUrl = window.location.href;

	// use the second link in the breadcrumbs for the current url - if there is a second link
	const $breadcrumbs = $('.breadcrumbs');
	const $firstLink = $breadcrumbs.find('li:nth-child(2) a');
	const currentUrl = $firstLink.length ? $firstLink.attr('href') : window.location.href;

	// change the currentURL to ignore GET params
	const currentUrlWithoutParams = currentUrl.split('?')[0];

	navLinks.forEach((link) => {
		const linkURL = link.href.split('?')[0];

		if (linkURL === currentUrlWithoutParams) {
			// find closest sub-menu
			const $link = $(link);
			// $parent.addClass('current_page_item');
			$link.addClass('current_page_item');
			$link.closest('.main-nav > li.menu-item').addClass('current_page_item');
		}
	});
})(jQuery);

// (function () {
// 	const toggle = document.querySelector('#toggle');
// 	const $target = document.querySelector('.main-nav-container');

// 	toggle.addEventListener('mousedown', function () {
// 		const isExpanded = this.getAttribute('aria-expanded') === 'true';

// 		this.setAttribute('aria-expanded', !isExpanded);
// 	});
// })();

(function ($) {
	const $toggle = $('#toggle');
	const $target = $('.navs-wrap');
	const $navScroll = $('.navs-wrap');
	const $header = $('.main-header');

	// Initialize ARIA attributes
	function initializeA11y() {
		// Ensure toggle button has proper ARIA attributes
		if (!$toggle.attr('aria-expanded')) {
			$toggle.attr('aria-expanded', 'false');
		}

		// Set initial aria-hidden state for navigation
		$target.attr('aria-hidden', 'true');

		// Ensure toggle button has proper labeling
		if (!$toggle.attr('aria-label') && !$toggle.attr('aria-labelledby')) {
			$toggle.attr('aria-label', 'Toggle navigation menu');
		}

		// Add role to navigation container if not present
		if (!$target.attr('role')) {
			$target.attr('role', 'navigation');
		}
	}

	// Initialize on DOM ready
	$(document).ready(initializeA11y);

	// Handle both click and keyboard events
	$toggle.on('click keydown', function (e) {
		// For keyboard events, only respond to Enter and Space
		if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
			return;
		}

		// Prevent default for both Enter and Space to avoid double firing and page scroll
		if (e.type === 'keydown') {
			e.preventDefault();
		}

		const isExpanded = this.getAttribute('aria-expanded') === 'true';

		if (isExpanded) {
			collapseNav();
		} else {
			expandNav();
		}
	});

	// Add escape key support to close navigation
	$(document).on('keydown', function (e) {
		if (e.key === 'Escape') {
			const isExpanded = $toggle.attr('aria-expanded') === 'true';
			if (isExpanded) {
				collapseNav();
				// Return focus to toggle button when closing with Escape
				$toggle.focus();
			}
		}
	});

	// Close navigation when clicking outside of .main-header
	$(document).on('click', function (e) {
		const isExpanded = $toggle.attr('aria-expanded') === 'true';

		// Only proceed if navigation is open
		if (!isExpanded) {
			return;
		}

		// Check if the click was outside .main-header
		if (!$(e.target).closest('.main-header').length) {
			collapseNav();
		}
	});

	function expandNav() {
		$toggle.attr('aria-expanded', 'true');
		$header.addClass('expanded');
		$target.addClass('expanded');

		// Announce to screen readers that navigation has opened
		$target.attr('aria-hidden', 'false');

		if (isMobileNav()) {
			bodyScrollLock.disableBodyScroll($navScroll[0]);

			// Focus the first focusable element in the navigation
			const firstFocusable = $target.find('a, button, [tabindex]:not([tabindex="-1"])').first();
			if (firstFocusable.length) {
				// Small delay to ensure the navigation is visible before focusing
				setTimeout(() => firstFocusable.focus(), 100);
			}
		}
	}

	function collapseNav() {
		$toggle.attr('aria-expanded', 'false');
		$header.removeClass('expanded');
		$target.removeClass('expanded');

		// Hide navigation from screen readers
		$target.attr('aria-hidden', 'true');

		bodyScrollLock.enableBodyScroll($navScroll[0]);
	}

	function isMobileNav() {
		// if .main-nav--desktop is visible, return false
		if ($('.main-nav--desktop').is(':visible')) {
			return false;
		}

		return true;
	}
})(jQuery);
